import * as actionTypes from 'redux/actions'

const initialState = {
  signup: {},
  updateAccountTrigger: 0,
  notificationsRefresher: 0,
  lastRefresh: new Date(),
  brandNameFilter: 'all',
  brandIDFilter: 'all',
  campaignsFilter: 'all',
  platformsFilter: 'all',
  advertiserCampaignId: 'all'
}

const unsavedReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_PASSWORD: {
      return {
        ...state,
        signup: { password: action.payload }
      }
    }
    case actionTypes.SET_FILE_URL: {
      return {
        ...state,
        assetFile: action.payload
      }
    }
    case actionTypes.UPDATE_ACCOUNT_TRIGGER: {
      return {
        ...state,
        updateAccountTrigger: state.updateAccountTrigger + 1
      }
    }
    case actionTypes.SET_BRANDS_NAME_FILTER: {
      return {
        ...state,
        brandNameFilter: action.payload
      }
    }

    case actionTypes.SET_ADVERTISER_CAMPAIGN_ID: {
      return {
        ...state,
        advertiserCampaignId: action.payload
      }
    }

    case actionTypes.SET_ADVERTISER_CAMPAIGN_NAME: {
      return {
        ...state,
        advertiserCampaignName: action.payload
      }
    }

    case actionTypes.SET_BRANDS_ID_FILTER: {
      return {
        ...state,
        brandIDFilter: action.payload
      }
    }
    case actionTypes.SET_CAMPAIGNS_FILTER: {
      return {
        ...state,
        campaignsFilter: action.payload
      }
    }

    case actionTypes.SET_PLATFORMS_FILTER: {
      return {
        ...state,
        platformsFilter: action.payload
      }
    }
    case actionTypes.REFRESH_NOTIFICATIONS: {
      return {
        ...state,
        notificationsRefresher: state.notificationsRefresher + 1,
        lastRefresh: new Date()
      }
    }
    default: {
      return state
    }
  }
}

export default unsavedReducer
